import React from 'react';
import { useTranslation } from 'react-i18next';
import { PublicLayout } from '../components/layouts';
import { Seo } from '../seo/Seo';
import { DeckHero, DeckSection, useDeckAnimateOnScroll } from '../components/landing/deck';

const sectionKeys = [
  'informationWeCollect',
  'howWeUseInformation',
  'dataSecurity',
  'contactUs',
] as const;

const Privacy: React.FC = () => {
  const { t } = useTranslation('privacy');
  useDeckAnimateOnScroll();

  return (
    <PublicLayout transparentHeader>
      <Seo route="/privacy" />

      <DeckHero title={t('privacy:title')} subtitle={t('privacy:lastUpdated')} />

      <DeckSection>
        <div className="max-w-3xl">
          <p className="text-lg text-white/70 leading-relaxed mb-12 animate-on-scroll">
            {t('privacy:intro')}
          </p>
          <div className="space-y-12">
            {sectionKeys.map((key) => (
              <section key={key} className="animate-on-scroll">
                <h2 className="text-2xl font-light text-white mb-4">
                  {t(`privacy:sections.${key}.title`)}
                </h2>
                <p className="text-base text-white/60 leading-relaxed">
                  {t(`privacy:sections.${key}.content`)}
                </p>
              </section>
            ))}
          </div>
        </div>
      </DeckSection>
    </PublicLayout>
  );
};

export default Privacy;
